export default __webpack_public_path__ + "static/media/checkbox-fill-green.163307fe.svg";